module.exports = __webpack_public_path__ + "static/media/dropdownarrow.af9a41cb.svg";